import queryString from 'query-string';
import { pickBy, isEqual } from 'lodash';
import { Location } from 'history';
import { Schema } from './parts/SearchForm';
import { EmployeesQueryVariables, SortColumn, SortOrder } from './query';

export interface SearchParams {
  q?: string;
  status?: 'all' | 'employed' | 'vacation' | 'unemployed' | 'join';
  office_ids?: string[];
  groups?: string[];
  positions?: string[];
  employment_types?: string[];
  _page?: string;
  limit?: string;
  sort_type?: string;
}

export const defaultSearchParams = {
  status: 'employed',
  _page: '1',
  sort_type: 'staff_code__asc'
} satisfies SearchParams;

export const getSearchParamsFromLocation = (location: Location): SearchParams => {
  return {
    ...defaultSearchParams,
    ...queryString.parse(location.search, { arrayFormat: 'bracket' })
  };
};

export const convertSearchParamsToQueryString = (params: SearchParams): string =>
  queryString.stringify(params, { arrayFormat: 'bracket' });

export const convertSearchParamsToForm = (params: SearchParams): Schema => {
  return {
    q: params.q || '',
    status: params.status || 'all',
    offices: params.office_ids || [],
    groups: params.groups || [],
    positions: params.positions || [],
    employmentTypes: params.employment_types || [],
    page: params._page || '1',
    limit: params.limit || '100',
    sortType: params.sort_type || defaultSearchParams.sort_type
  };
};

export const convertFormToSearchParams = (form: Schema): SearchParams => {
  return pickBy({
    q: form.q,
    status: form.status,
    office_ids: form.offices,
    groups: form.groups,
    positions: form.positions,
    employment_types: form.employmentTypes,
    _page: form.page,
    limit: undefined, // limitはSearchParamsに含めない
    sort_type: form.sortType
  });
};

export const convertSearchParamsToGraphQL = (params: SearchParams): EmployeesQueryVariables => {
  const [sortColumn, sortOrder] = (params.sort_type || defaultSearchParams.sort_type).split('__');
  return {
    page: Number(params._page) || 1,
    limit: Number(params.limit) || 100,
    search: {
      status: params.status || 'employed',
      q: params.q,
      offices: params.office_ids,
      groups: params.groups,
      positions: params.positions,
      employmentTypes: params.employment_types,
      sortColumn: sortColumn as SortColumn,
      sortOrder: sortOrder as SortOrder
    }
  };
};

export const hasConditions = (form: Schema): boolean => {
  return !isEqual(
    pickBy(convertFormToSearchParams(form), v => (Array.isArray(v) ? v.length > 0 : v)),
    defaultSearchParams
  );
};
